import { PATH as CONFIGURATION_PATH } from '../const';

export const PATH = `${CONFIGURATION_PATH}/session`;
